import VideoHls from "./components/video-hls";
import Marque from "./sliders/marque";
import MainNewSlider from "./sliders/main-slider-new";
import ReadSlider from "./sliders/read-slider";
import HBOSlider from "./sliders/HBOSlider";
import PodcastsSlider from "./sliders/podcasts-slider";
import PodcastsBestSlider from "./sliders/podcasts-best-slider";
import StickyBlocks from "./components/sticky-blocks";
import Swiper from "swiper";
import SwipeButton from "./components/swipe-button";
import ModalVideo from "./components/modal-video";

document.addEventListener("DOMContentLoaded", () => {
	new MainNewSlider();
	new ReadSlider();
	new HBOSlider();
	new PodcastsSlider();
	new PodcastsBestSlider();
    new StickyBlocks();

	function getMoviesCollectionsSliderOffset () {
		let containerPadding = 0;
		if (window.innerWidth >= 576 && window.innerWidth <= 991) {
			containerPadding = 46;
		} else if (window.innerWidth >= 376 && window.innerWidth <= 575) {
			containerPadding = 20;
		} else if (window.innerWidth >= 350 && window.innerWidth <= 375) {
			containerPadding = 16;
		} else if (window.innerWidth <= 349) {
			containerPadding = 12;
		}

		return window.innerWidth - (Math.floor(window.innerWidth / 160) * 160) - ((Math.floor(window.innerWidth / 160) - 1) * 16) - (containerPadding * 2);
	}

	new Swiper('#movies-collections .movies-collections--main_mob .movies-collections--main__line', {
		loop: false,
		grabCursor: true,
		spaceBetween: 16,
		slidesPerView: 'auto',
		updateOnWindowResize: true,
		slidesOffsetAfter: getMoviesCollectionsSliderOffset()
	});

	if (window.innerWidth >= 576) {
		new Marque(".watch-today--inner .watch-today--wrapper:nth-child(1)", 1);
		new Marque(".watch-today--inner .watch-today--wrapper:nth-child(2)", -1);
		new Marque(".watch-today--inner .watch-today--wrapper:nth-child(3)", 1);
		new Marque(".watch-today--inner .watch-today--wrapper:nth-child(4)", -1);
		new Marque(".watch-today--inner .watch-today--wrapper:nth-child(5)", 1);
	}

	if (window.innerWidth <= 575) {
		new SwipeButton('.show-now--btn-all', '.show-now--btn-all__arrow');
	}

	document.querySelectorAll('.simulated-hover').forEach(element => {
		element.addEventListener('touchstart', () => element.classList.add('_hover'));
		element.addEventListener('touchend', () => element.classList.remove('_hover'));
	});

	let intervalId: any;
	let isWorks = false;
	const container = document.querySelector('.movies-collections--main.d-none.d-lg-flex');
	const lines = Array.from(document.querySelectorAll('.movies-collections--main__line_anim'));
	const elements = Array.from(document.querySelectorAll('.movies-collections--main__item_anim'));
	function addingClasses() {
		const randomElement = elements[Math.floor(Math.random() * elements.length)];
		const elementParent = randomElement.parentNode as HTMLElement;

		lines.forEach((element) => {
			element.classList.remove('_hover');
		});
		elements.forEach((element) => {
			element.classList.remove('_hover');
		});

		elementParent.classList.add('_hover');
		randomElement.classList.add('_hover');
	}

	function startAddingClasses() {
		if (!isWorks) {
			intervalId = setInterval(addingClasses, 3000);
			isWorks = true;
		}
	}

	function stopAddingClasses() {
		lines.forEach((element) => {
			element.classList.remove('_hover');
		});
		elements.forEach((element) => {
			element.classList.remove('_hover');
		});

		if (isWorks) {
			clearInterval(intervalId);
			isWorks = false;
		}
	}

	container.addEventListener('mousemove', () => {
		stopAddingClasses();
	});

	container.addEventListener('mouseout', () => {
		if (window.innerWidth >= 576) {
			startAddingClasses();
		}
	});

	if (window.innerWidth >= 576) {
		startAddingClasses();
	}
});

window.onload = () => {
	setTimeout(() => {
		let showNowVideoWrapper = document.querySelector('.show-now--realtime__playable .show-now--realtime__video') as HTMLElement;
		if (showNowVideoWrapper) {
			new VideoHls(showNowVideoWrapper, {
				onPlayStart: () => {
					showNowVideoWrapper.classList.add('active');
				}
			});
		}
	}, 400)
}
